import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import "./newcampaign.css";
import CreatDripModal from "./CreatDripModal";

const NewCampaignCard = () => {
  const navigate = useNavigate();
  const [newCardModal, setNewCardModal] = useState(false);

  const toggleNewCardModal = () => {
    setNewCardModal(!newCardModal);
  };

  return (
    <>
      <div className="card card-blank" onClick={toggleNewCardModal}>
        <div className="card-content">
          <Plus style={{ color: "#d1d5db" }} />
          <div style={{ color: "#d1d5db" }}>Drip Campaign Setup</div>
        </div>
      </div>
      <CreatDripModal isOpen={newCardModal} onClose={toggleNewCardModal} />
    </>
  );
};

export default NewCampaignCard;
